<template>
<div class="blank">
    <div class="credit-list">
        <img src="../assets/images/credit-header-bg.jpg" alt="">
        <ul>
            <li v-for="(item,index) in list" :key="index">
                <a :href="item.contentLink">
                    <img :src="item.pictureLink" />
                    <div class="cl-r">
                        <h2>{{item.contentName}}</h2>
                        <p class="blue-one">{{item.addContentOne}}</p>
                        <p>{{item.addContentTwo}}</p>
                        <p>{{item.addContentThree}}</p>
                    </div>
                    <i></i>
                </a>
            </li>
        </ul>
    </div>
    <loading v-show="isLoading"></loading>
</div>
</template>
<style lang="scss" scoped>
@import '../assets/styles/all.scss';
.credit-list {

    max-width: 640px;
    img {
        max-width: 100%;
    }
    background: #ffffff;
    ul {
        box-sizing: border-box;
        padding-left: r(15);
        li {
            // display: -webkit-box;
            border-bottom: 0.5px solid rgb(230,230,230);
            padding: r(15) 0;
            position: relative;
            a {
                display: -webkit-box;
                -webkit-box-align: center;
                width: 100%;
                height: r(80);
            }
            img {
                // float: left;
                width: r(105);
                height: r(66);
                vertical-align: middle;
            }
            i {
                display: inline-block;
                width: r(7);
                height: r(12);
                background: url("../assets/images/link.png") no-repeat;
                background-size: 100% 100%;
                position: absolute;
                top: 50%;
                -webkit-transform: translateY(-50%);
                right: r(15);
                z-index: 2;
            }
        }
        li:last-child {
            border-bottom: none;
        }
    }
    .cl-r {
        max-width: r(260);
        position: relative;
        overflow: hidden;
        -webkit-box-flex: 1;
        padding-left: r(10);
        padding-top: r(2);
        h2 {
            font-size: r(15);
            font-weight: 500;
            color: rgb(51,51,51);
        }
        p {
            font-size: r(12);
            line-height: r(16);
            color: rgb(167,167,167);
        }
        .blue-one{
            color: rgb(85,166,255)
        }
    }
}
</style>
<script>
import {
    Group,
    Cell
} from 'fiui'
import {
    list
} from '../utils/faq.js'
import storage from '../utils/storage'
import Loading from '../components/loading';
import {
    api
} from '../api/axios';

export default {
    data() {
        return {
            list: [],
            isLoading: true
        }
    },
    components: {
        Group,
        Cell,
        Loading
    },
    created() {

    },
    beforeRouteEnter(to, from, next) {
        document.title = '办信用卡'
        next()
    },
    mounted() {
        // let columnLink=window.location.href
        let columnLink = window.location.protocol + '//' + window.location.host + window.location.pathname + '#/creditlist'
        if (columnLink.indexOf('http://localhost:') > -1) {
            columnLink = 'https://one-test.zhongan.com/fcp/diandian/#/creditlist'
        }

        api({
            id: 'cmsAPI.pagedQueryColumnContents',
            param: {
                'columnLink': columnLink,
                'contentStatus': 0,
                "pageInfo": {
                    "currentPage": 1,
                    "pageSize": 100
                }
            }
        }).then((res) => {
            if (res.data.status == "SUCCESS") {
                this.isLoading = false;
                if (res.data.code == 1) {
                    //成功
                    var data = res.data.data.dataList
                    console.log(data);
                    this.list = data
                } else {
                    this.toastMsg = data.message;
                    this.isToast = true;
                }
            }
        }).catch((error) => {
            this.toastMsg = '请求失败';
            this.isToast = true;
            this.isLoading = false;
        })
    },
    methods: {

    }
}
</script>



// WEBPACK FOOTER //
// creditlist.vue?d8248dee